export default "__VITE_ASSET__oGjeCb46__"